<template>
	<div class="d-flex align-items-center">
		<UiElement tag="button" :settings="settings" @click="removeCount">
			-
		</UiElement>

		<div class="d-flex align-items-center justify-content-center" style="width: 50px">
			<slot v-bind="{ count }" />
		</div>

		<UiElement tag="button" :settings="settings" @click="addCount">
			+
		</UiElement>
	</div>
</template>

<script setup>
	import { computed, defineProps } from 'vue';
	import { useOrderStore } from '@/stores/useOrderStore';
	import UiElement from '@/components/UI/UiElement.vue';

	const { addProduct, removeProduct, getAmount } = useOrderStore();

	const props = defineProps({
		settings: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true
		}
	});

	const count = computed(() => {
		return getAmount(props.product.id);
	});

	function addCount() {
		if (count.value === 99) return;

		addProduct(props.product);
	}

	function removeCount() {
		if (count.value === 0) return;

		removeProduct(props.product);
	}
</script>